<template>
    <div
        class="o-d-explore"
    >
        <div class="ui mobile-explore-header">
            <AMBackButton
                theme="home"
                :text="$t('ui.home')"
                class="p-desktop-explore__home-button"
                @onClick="handleBackHome"
            />
            <AMBackButton
                v-if="$route.params.canGoBack"
                theme="back"
                :text="$t('ui.back')"
                class="p-desktop-explore__back-button"
                @onClick="handleBack"
            />
        </div>
    </div>
</template>

<script>
import {DESKTOP_START} from "@/utils/constants/pages";
import AMBackButton from "@/components/atoms/a-m-back-button/a-m-back-button";

export default {
    name: 'ODExplore',
    components: {
        AMBackButton
    },
    methods: {
        handleBackHome(){
            this.$router.push({ name: DESKTOP_START });
        },
        handleBack() {
            this.$router.back();
        },
    }
}
</script>

<style lang="scss">
@import "o-d-explore";
</style>
